document.addEventListener('DOMContentLoaded', () => {
  const printButtons = document.querySelectorAll('button[id^="print-product-"]');

  if (!printButtons.length) return;

  // --- 1. BALANCED COMPRESSION HELPER (1-3MB Target) ---
  const getBalancedUrl = (src, sizeStr) => {
    if (!src) return '';
    
    // Step A: Remove any existing Shopify size suffix
    let baseSrc = src.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|1024x1024|2048x2048|master)(?=\.)/g, '');

    // Step B: Inject new size
    let newSrc = baseSrc.replace(/(\.[a-z0-9]+)(\?v=.*)?$/i, `_${sizeStr}$1$2`);

    // Step C: Use Quality 75 (Standard) instead of 50
    const separator = newSrc.includes('?') ? '&' : '?';
    return `${newSrc}${separator}format=jpg&quality=75`;
  };

  printButtons.forEach(button => {
    button.addEventListener('click', (e) => {
      e.preventDefault();

      const isMobile = window.innerWidth <= 768;

      // --- 2. GATHER DATA ---
      const productTitle = document.querySelector('.product__title h1')?.textContent.trim() || 'Rug';
      const currentUrl = window.location.href;
      
      let retailPrice = null, tradePrice = null, clearancePrice = null, generalPrice = null;
      const allElements = document.querySelectorAll('.product__info-container p, .product__info-container div, .price-container');
      
      for (const el of allElements) {
        const text = el.innerText;
        if (text.includes('Retail:')) retailPrice = text.match(/Retail:\s*(\$[\d,.]+)/i)?.[1].replace(/\.00$/, '');
        if (text.includes('Trade:')) tradePrice = text.match(/Trade:\s*(\$[\d,.]+)/i)?.[1].replace(/\.00$/, '');
        if (text.includes('Clearance:')) clearancePrice = text.match(/Clearance:\s*(\$[\d,.]+)/i)?.[1].replace(/\.00$/, '');
        if (retailPrice && (tradePrice || clearancePrice)) break;
      }

      if (!retailPrice && !tradePrice && !clearancePrice) {
        const priceEl = document.querySelector('.price-item--regular, .price__regular .price-item, .product__price');
        if (priceEl) generalPrice = priceEl.textContent.trim().replace(/\.00$/, '');
      }

      // --- 3. IMAGE SELECTION ---
      const allGalleryImages = document.querySelectorAll('.product__media img, .product__media-item img');
      const uniqueImageSrcs = [];
      const seenSrcs = new Set();
      for (let img of allGalleryImages) {
        if (uniqueImageSrcs.length >= 3) break;
        if (!seenSrcs.has(img.src)) {
          seenSrcs.add(img.src);
          uniqueImageSrcs.push(img.src);
        }
      }

      // --- 4. APPLY BALANCED SIZING ---
      // Main: 1024x1024 (Sharp enough for print, small enough for email)
      // Thumbs: large (480px)
      const mainImageSrc = uniqueImageSrcs[0] ? getBalancedUrl(uniqueImageSrcs[0], '1024x1024') : '';
      const image2Src = uniqueImageSrcs[1] ? getBalancedUrl(uniqueImageSrcs[1], 'large') : '';
      const image3Src = uniqueImageSrcs[2] ? getBalancedUrl(uniqueImageSrcs[2], 'large') : '';

      const logoUrl = "https://cdn.shopify.com/s/files/1/0606/9852/5828/files/logo-black.png?v=1744917691&width=300"; 

      // --- 5. GATHER SPECS ---
      let specRows = [];
      const potentialContainers = document.querySelectorAll('.accordion__content, .rte, .product__description p');
      for (const el of potentialContainers) {
        if (el.innerHTML.includes('Rug Number')) {
          const temp = document.createElement('div');
          temp.innerHTML = el.innerHTML.replace(/<br\s*\/?>/gi, '\n').replace(/<\/p>/gi, '\n');
          const lines = (temp.textContent || '').split('\n');
          const unwanted = new Set(['Guests', 'Trade', 'Note', 'Description']);
          lines.forEach(line => {
            const cleanLine = line.trim();
            if (cleanLine.includes(':') && cleanLine.length > 3) {
              const [label, ...rest] = cleanLine.split(':');
              const finalLabel = label.trim();
              const value = rest.join(':').trim();
              if (finalLabel && value && !unwanted.has(finalLabel) && !finalLabel.includes('Retail') && !finalLabel.includes('Trade') && !finalLabel.includes('Clearance')) {
                specRows.push(`<div class="spec-row"><strong>${finalLabel}:</strong> ${value}</div>`);
              }
            }
          });
          break; 
        }
      }

      let priceHtmlBlock = '';
      if (retailPrice || tradePrice || clearancePrice) {
          priceHtmlBlock = `
            <div class="price-header">
              ${retailPrice ? `<span class="price-item"><strong>Retail:</strong> ${retailPrice}</span>` : ''}
              ${tradePrice ? `<span class="price-item"><strong>Trade:</strong> ${tradePrice}</span>` : ''}
              ${clearancePrice ? `<span class="price-item" style="color: #d00;"><strong>Clearance:</strong> ${clearancePrice}</span>` : ''}
            </div>
          `;
      } else if (generalPrice) {
          priceHtmlBlock = `
            <div class="price-header">
              <span class="price-item"><strong>Price:</strong> ${generalPrice}</span>
            </div>
          `;
      }

      const half = Math.ceil(specRows.length / 2);
      const leftColumnSpecs = specRows.slice(0, half).join('');
      const rightColumnSpecs = specRows.slice(half).join('');
      
      const themeBodyFont = getComputedStyle(document.body).fontFamily;
      const headingElement = document.querySelector('h1, h2, h3');
      const themeHeadingFont = headingElement ? getComputedStyle(headingElement).fontFamily : themeBodyFont;

      const viewportTag = isMobile 
         ? '<meta name="viewport" content="width=816">' 
         : '<meta name="viewport" content="width=device-width, initial-scale=1.0">';

      const closeButtonHTML = isMobile 
         ? `<button onclick="window.close()" class="no-print" style="position: fixed; bottom: 30px; left: 50%; transform: translateX(-50%); z-index: 9999; width: 80%; max-width: 300px; padding: 16px 24px; background: #000; color: #fff; border: none; font-size: 18px; font-weight: bold; border-radius: 50px; cursor: pointer; box-shadow: 0 4px 12px rgba(0,0,0,0.3);">Return to Shop</button>` 
         : '';

      const unifiedHTML = `
        <!DOCTYPE html>
        <html lang="en">
          <head>
            <title>${productTitle} - Tear Sheet</title>
            <meta charset="utf-8">
            ${viewportTag}
            <style>
              *, *:before, *:after { box-sizing: border-box; }
              html, body { margin: 0; padding: 0; width: 100%; height: 100%; background: #fff; font-family: ${themeBodyFont}, sans-serif; -webkit-print-color-adjust: exact; print-color-adjust: exact; overflow-x: hidden; }
              @media screen and (max-width: 768px) { html, body { zoom: 0.75; } }
              @media print { html, body { zoom: 1 !important; overflow: visible !important; } .no-print { display: none !important; } @page { margin: 0; size: 8.5in 11in; } }
              h1 { font-family: ${themeHeadingFont}, serif; font-weight: normal; font-size: 24px; margin: 0 0 5px 0; color: #000; flex-shrink: 0; line-height: 1.1; }
              .price-header { margin-bottom: 15px; margin-top: 4px; padding-left: 4px; font-size: 14px; color: #000; display: flex; gap: 30px; }
              .price-item strong { font-weight: 700; }
              .sheet-container { display: flex; flex-direction: column; width: 8.5in; min-height: 10.75in; padding: 0.65in 0.5in 0.5in 0.5in; position: relative; background: white; flex-shrink: 0; }
              .header { display: flex; justify-content: space-between; align-items: center; border-bottom: 2px solid #000; padding-bottom: 8px; margin-bottom: 12px; flex-shrink: 0; }
              .logo { height: 38px; width: auto; object-fit: contain; }
              .date { font-size: 10px; color: #666; text-transform: uppercase; }
              .images-container { display: flex; gap: 25px; flex: 2; padding-bottom: 20px; min-height: 0; overflow: hidden; }
              .main-image-left { flex: 3; height: 100%; display: flex; align-items: center; padding-left: 40px; overflow: hidden; }
              .side-images-right { flex: 1.3; display: flex; flex-direction: column; height: 100%; padding-right: 80px; padding-top: 45px; padding-bottom: 20px; gap: 20px; }
              .side-image-wrapper { width: 100%; aspect-ratio: 3 / 4; position: relative; overflow: hidden; flex: 0 0 auto; }
              .side-image-wrapper img { width: 100%; height: 100%; object-fit: cover; object-position: center; display: block; }
              img.print-image.main { width: 100%; height: 100%; object-fit: contain; object-position: center; }
              .specs-container { display: grid; grid-template-columns: 1fr 1fr; gap: 15px; padding-top: 12px; border-top: 1px solid #eee; flex-shrink: 0; }
              .spec-row { margin-bottom: 10px; font-size: 11px; color: #000; border-bottom: 1px solid #f4f4f4; padding-bottom: 2px; display: flex; align-items: baseline; }
              .spec-row strong { font-weight: 700; width: 110px; display: inline-block; flex-shrink: 0; }
              .footer { padding-top: 10px; display: flex; justify-content: space-between; align-items: flex-end; border-top: 2px solid #000; flex-shrink: 0; margin-top: auto; }
              .contact-info { font-size: 11px; line-height: 1.5; color: #888; }
              .qr-container { text-align: right; }
              .qr-code { width: 60px; height: 60px; margin-bottom: 5px; object-fit: contain; }
              .scan-text { font-size: 9px; text-transform: uppercase; letter-spacing: 1px; color: #888;}
            </style>
          </head>
          <body>
            ${closeButtonHTML}
            <div class="sheet-container">
              <div class="header">
                <img src="${logoUrl}" class="logo">
                <span class="date">${new Date().toLocaleDateString()}</span>
              </div>
              <h1>${productTitle}</h1>
              ${priceHtmlBlock}
              <div class="images-container">
                <div class="main-image-left">
                  <img src="${mainImageSrc}" class="print-image main wait-for-print" loading="eager">
                </div>
                <div class="side-images-right">
                  ${image2Src ? `<div class="side-image-wrapper"><img src="${image2Src}" class="wait-for-print" loading="eager"></div>` : ''}
                  ${image3Src ? `<div class="side-image-wrapper"><img src="${image3Src}" class="wait-for-print" loading="eager"></div>` : ''}
                </div>
              </div>
              <div class="specs-container">
                <div class="column">${leftColumnSpecs}</div>
                <div class="column">${rightColumnSpecs}</div>
              </div>
              <div class="footer">
                <div class="contact-info">
                  <strong>Wooden Looms Rug Gallery</strong><br>
                  6415 Burnet Ln<br>Austin, TX 78757<br>
                  512-888-3949<br>info@woodenlooms.com
                </div>
                <div class="qr-container">
                  <img src="https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${encodeURIComponent(currentUrl)}" class="qr-code wait-for-print">
                  <div class="scan-text">Scan to View Online</div>
                </div>
              </div>
            </div>
            <script>
              const images = document.querySelectorAll('.wait-for-print');
              let loadedCount = 0;
              let hasPrinted = false;
              const finalize = () => {
                if (hasPrinted) return;
                hasPrinted = true;
                setTimeout(() => { window.print(); }, 500);
              };
              const checkProgress = () => {
                loadedCount++;
                if (loadedCount >= images.length) finalize();
              };
              if (images.length === 0) finalize();
              else {
                images.forEach(img => {
                  if (img.complete) checkProgress();
                  else { img.onload = checkProgress; img.onerror = checkProgress; }
                });
              }
              setTimeout(finalize, 4000); 
            <\/script>
          </body>
        </html>
      `;

      if (isMobile) {
        const win = window.open('', '_blank');
        if (win) {
          win.document.write(unifiedHTML);
          win.document.close();
        }
      } else {
        let iframe = document.getElementById('print-iframe-hidden');
        if (iframe) iframe.remove();
        
        iframe = document.createElement('iframe');
        iframe.id = 'print-iframe-hidden';
        iframe.style.position = 'fixed';
        iframe.style.width = '1px';
        iframe.style.height = '1px';
        iframe.style.opacity = '0.01';
        iframe.style.pointerEvents = 'none';
        iframe.style.border = 'none';
        
        document.body.appendChild(iframe);
        const doc = iframe.contentWindow.document;
        doc.open();
        doc.write(unifiedHTML);
        doc.close();
      }
    });
  });
});